import auth from './auth.js';
import rbac from './rbac.js';
import teams from './teams.js';

export default { auth, rbac, teams };
